import { useState, useEffect } from 'react';
import {Space, Row, Button, Table, Divider, message, PageHeader,Col, Statistic, Card} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

import MakeAdd from './MakeAdd';
import MakeUpdate from './MakeUpdate';
import axios from 'axios';

const MakeComponent = ()=>{

    const [makeData, setMakeData] = useState()
    const [makeTotal, setMakeTotal] = useState([])

    const getAllMake = () => {
        let getMake = `${FetchVariable.Heroku}/make/`
        axios.get(getMake)
            .then((res)=>{
                let data =res.data
                setMakeData(data)
                setMakeTotal(data.length)
            })
        }
    
    function deleteMake (deleteID) {
            let deleteAuction = `${FetchVariable.Heroku}/make/`+deleteID
            axios.delete(deleteAuction)
                .then(() => {
                    getAllMake()
                    message.error('The make is deleted')
        })
    }

    const addMake = (addMakeData)=>{
            let apiURL = `${FetchVariable.Heroku}/make/`
            axios.post(apiURL, addMakeData)
            .then(() => {
                getAllMake()
            })
            .catch(err=>{console.log(err)})
    }
    const updateMake = (updateMake)=>{
            let apiURL = `${FetchVariable.Heroku}/make/`
            axios.put(apiURL, updateMake)
            .then(() => {
                getAllMake()
            })
            .catch(err=>{console.log(err)})
    }

    useEffect(() => {
        getAllMake();
    }, [])

    let makeFilter = []
    const key = 'text';

    makeData?.forEach((e)=>{makeFilter.push({text:e.Make,value:e.Make})})
    const uniqueMakeFilter = [...new Map(makeFilter.map(item =>
    [item[key], item])).values()];

        const MakeColums = [
        {
            title: 'Make ID',
            dataIndex: 'MakeID',
            key: 'MakeID',
        },
        {
            title: 'Make Name',
            dataIndex: 'Make',
            key: 'Make',
            filters: uniqueMakeFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Make.indexOf(value) === 0,
        },
        {
            title: 'Make Icon',
            dataIndex: 'MakeIcon',
            key: 'MakeIcon',
            render:(record, value)=>{
                if (value.Make === null){
                    return(
                        <p style={{marginBottom:'auto', marginTop:'auto', marginLeft:'7px'}}>N/A</p>
                    )                
                }else {
                    return(
                        <img src={`https://img.icons8.com/color/48/000000/${value.Make.toLowerCase()}.png`} alt={value.Make}/>
                    )
                }
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <MakeUpdate record={record} updateMake={updateMake}/>
                <Button onClick={()=> deleteMake(record.MakeID) } type="primary" danger icon={<DeleteOutlined />}></Button>
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Car Make Management"
            extra={[ 
                <MakeAdd key='addMake' addMake={addMake}/>,
            ]}
            >

                <Col span={6}>
                    <Card>
                        <Statistic title="Make Total" value={makeTotal} />
                    </Card>
                </Col>
            </PageHeader>

            <Divider />
            <Row>
                <Table columns={MakeColums} dataSource={makeData} rowKey={(record)=>record.MakeID} scroll={{x:1500, y:1000}}/>
            </Row>
        </>
    )
}

export default MakeComponent